import { ThirdPartyEvaluationFormItemFile } from '../thirdparty-evaluation-form-item-file';

export class DueDiligenceRequest {
    id: number = 0;
    thirdPartyEvaluationId: number = 0;

    evaluationScore: number = 0;// no pasar
    active: boolean = true;

    /* Header */
    thirdPartyId: number = 0; 
    thirdParty: {
        id: number;
        name: string;
        cityId: number;
        typeId: number;
        tenantId: number;
    };
    dueDiligenceLevelId: number = 0;
    dueDiligencePriorityId: number = 0;    
    dueDiligenceProviderId: number = 0;
    deliveryDate: Date = null;
    slaDate: Date = null;
    /* Register */
    thirdPartyName: string = ''; // registeredName
    localName: string = '';
    alias: string = '';
    typeOfThirdPartyId: number = 0; // idTypeID
    numberId: string = ''; // internationalRegisterIdNumber, not an ID
    /* Investigated */
    countryId: number = 0;    
    incorporationDate: Date = null; // admissionDate
    legalStructure: string = ''; // businessStructure
    legacyRegister: string = '';  //fileNumber
    /* Location */
    address: string = '';
    cityId: number = 0;    
    stateId: number = 0;
    /* Contact information */
    webSite: string = '';
    email: string = '';
    contactEmail: string = '';  // poner el mismo email en los dos
    phone: string = '';    
    /* Personal History */
    serviceProvided: string = '';
    executives: string = ''; // managers
    shareholders: string = '';
    /* Extras */
    comment: string = '';
    /* Files */
    filesIds: number[] = [];
    filesWithItemDtos: {
        thirdPartyEvaluationFormItemId: number;
        createUser: string;
        file: ThirdPartyEvaluationFormItemFile
    }[];
    
     
    dueDiligenceStatusId: number = 0; // mandar en null

    constructor() {
    }
}

